// extracted by css-extract-rspack-plugin
export default {"square":"_2w3zTMWTBLXaMQ0NeCpbBC","assistantCoachInput":"_1XORLiIwJV_gXpfe3AJKmz","progressBar":"_2gjQaUr2fH7SpEFdOX1eLR"};